import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Select, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

@inject('apiToolsStore','apiManagementStore','mappingManagementStore','uiState')
@observer
class SearchForm extends Component {
  state={
    customer: undefined,
    directionType: 'INBOUND',
    fileList: []
  }
  formRef = React.createRef();
	componentDidMount() {
		const { mappingManagementStore, apiToolsStore } = this.props
    mappingManagementStore.onGetinboundCustomerAction()
    apiToolsStore.onChangeResendList([])
  }
  onChange=(value)=>{
    const { apiManagementStore } = this.props
    const { searchItem, searchItemInbound } = apiManagementStore
    this.setState({
      customer: undefined,
    })
    this.formRef.current.setFieldsValue({
      customer: undefined,
      apiName: undefined,
    })
    apiManagementStore.onChangeDirectionType(value)
    if(value==='OUTBOUND') {
      apiManagementStore.onSearchApiAction(searchItem, 1, 99999)
    }else {
      apiManagementStore.onSearchInboundAction(searchItemInbound, 1, 9999999)
    }
  }
  onChangeInboundOutbound=(value)=>{
    const { mappingManagementStore } = this.props
    const { directionType } = this.state
    this.formRef.current.setFieldsValue({
      apiName:undefined
    })
    this.setState({
      customer: value,
    })
    if(directionType==='OUTBOUND') {
      mappingManagementStore.onGetOutboundNameAction(value)
      if(value===undefined){
        this.formRef.current.setFieldsValue({
          apiName:undefined
        })
        this.setState({
          customer: undefined
        })
      }
    }else {
      mappingManagementStore.onGetInboundNameAction(value)
      if(value===undefined){
        this.formRef.current.setFieldsValue({
          apiName: undefined
        })
        this.setState({
          customer: undefined
        })
      }
    }
  }
  handleResend=()=>{
    const { apiToolsStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      apiToolsStore.onResendAction(fieldsValue.apiName,fieldsValue.customer,fieldsValue.direction,fieldsValue.files.fileList)
    }).catch(err => {})
  }

  onChangeUpload = (info) => {
    info.onSuccess()
  }
  handleChange = (info) => {
      if(info.fileList.length===0){
        this.formRef.current.setFieldsValue({
          files: undefined
        })
      }
  }
  handleExport = () => {
    const { apiToolsStore,uiState } = this.props
    uiState.onChangeFetchingExport('/open/api/v1/push-log/message/upload/resend/export', {body:apiToolsStore.resendList||[]}, `Mass Resend.xlsx`)
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 6},
      wrapperCol: { span: 18 },
    }
		const { mappingManagementStore } = this.props
		const { directionType } = this.state
    const { inboundCustomerList, inboundNameList, outboundNameList } = mappingManagementStore
    return (
      <>
				<Form ref={this.formRef} initialValues={{direction:'INBOUND'}} size='middle'>
					<Row>
            <Col span={8}>
              <Form.Item name='direction' label='Direction' rules={[{ required: true, message: 'Please select Direction.' }]}>
                <Select placeholder="Please select ..." onChange={this.onChange}>
                  <Select.Option key='INBOUND' value='INBOUND'>INBOUND</Select.Option>
                  {/*<Select.Option key='OUTBOUND' value='OUTBOUND'>OUTBOUND</Select.Option>*/}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='customer' label='Customer' {...formItemLayout} rules={[{ required: true, message: 'Please select Customer.' }]}>
                <Select placeholder="Please select ..." allowClear showSearch onChange={this.onChangeInboundOutbound}>
                  {
                    inboundCustomerList.map(item => <Select.Option key={item.id} value={item.id}>{item.customer}</Select.Option>)
                  }
                </Select>
              </Form.Item>
            </Col>
						<Col span={8}>
							<Form.Item name='apiName' label='Connect Name' {...formItemLayout} rules={[{ required: true, message: 'Please select Connect Name.' }]}>
								<Select placeholder="Please select ..." allowClear showSearch disabled={this.state.customer === undefined}>
									{
                                      directionType==='INBOUND'?
                    inboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>):
                    outboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)
									}
								</Select>
							</Form.Item>
						</Col>
            <Col span={20} style={{paddingLeft: 80,marginTop:10}}>
              <Form.Item name='files' rules={[{ required: true, message: 'Please enter Files.', }]}>
              <Upload multiple
                      accept=".txt,.json,.xml"
                      customRequest={this.onChangeUpload}
                      style={{ width: '100%', margin: '0 auto' }}
                      onChange={this.handleChange}
              >
                <Button icon={<UploadOutlined />} >Click to Upload</Button>
              </Upload>
              </Form.Item>
            </Col>
            <Col span={4} style={{textAlign: 'right',marginTop:10}}>
              <Button onClick={this.handleResend} type='primary' style={{marginLeft:10}}>Resend</Button>
              <Button onClick={this.handleExport} type='primary' style={{marginLeft:10}}>Export</Button>
            </Col>
					</Row>
				</Form>
      </>
    );
  }
}

export default SearchForm;
